import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import { GlobalMessageService, GlobalMessageType, UserIdService, } from '@spartacus/core'

import { BehaviorSubject, EMPTY } from 'rxjs'
import { UntypedFormGroup } from '@angular/forms'
import { filter, map, skip, startWith, tap, withLatestFrom } from 'rxjs/operators'
import { DataAnalyticsClickSource, MbConstants } from 'src/app/mb/shared/mb-constants'
import { Router } from '@angular/router'
import { CartCheckoutService } from '../../services/mb-cart-checkout.service'
import { CartItemListComponent } from '@spartacus/cart/base/components'
import { ActiveCartService, MultiCartService, SelectiveCartService } from '@spartacus/cart/base/core'
import { OrderEntry } from '@spartacus/cart/base/root'

@Component({
  selector: 'mb-cart-item-list',
  templateUrl: './mb-cart-item-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MbCartItemListComponent extends CartItemListComponent implements OnInit {

  @Input() isDisplayedInCartPage = true

  @Input() isCustomerSpecificPrices = false

  @Input() showAddToCartButton = false

  @Input() dataAnalyticsClickSource: DataAnalyticsClickSource | undefined

  showYourPrice$ = new BehaviorSubject<boolean>(false)

  constructor (activeCartService: ActiveCartService,
               selectiveCartService: SelectiveCartService,
               userIdService: UserIdService,
               multiCartService: MultiCartService,
               cd: ChangeDetectorRef,
               private globalMessageService: GlobalMessageService,
               private router: Router,
               private cartCheckoutService: CartCheckoutService) {
    super(activeCartService, selectiveCartService, userIdService, multiCartService, cd)
  }

  ngOnInit (): void {
    //TODO refactor here
    if (this.items && !this.isDisplayedInCartPage) {
      if (this.router.url?.includes(MbConstants.CHECKOUT_REVIEW_PAGE)) {
        const erpPricesAreCustomerSpecific$ = this.activeCartService.getActive().pipe(
          filter(() => this.router.url?.includes(MbConstants.CHECKOUT_REVIEW_PAGE)),
          skip(1),
          tap(cart => cart.erpPricingError &&
            this.globalMessageService.add({ key: 'mbcart.failedOrderSimulateMessage' }, GlobalMessageType.MSG_TYPE_ERROR, 17000)),
          map(cart => !!(!cart.erpPricingError && cart?.erpPricesAreCustomerSpecific))
        )
        erpPricesAreCustomerSpecific$.subscribe(this.showYourPrice$)
      } else if (this.router.url?.includes(MbConstants.CHECKOUT_CONFIRMATION_PAGE)) {
        const erpShowYourPrice$ = this.cartCheckoutService.isCustomerSpecificOrder()
        erpShowYourPrice$.subscribe(this.showYourPrice$)
      } else {
        this.showYourPrice$.next(this.isCustomerSpecificPrices)
      }
    }
  }

  getControl (item: OrderEntry) {
    return this.form.get(this.getControlName(item))?.valueChanges.pipe(
      startWith(null),
      withLatestFrom(this.activeCartService.getActiveCartId()),
      map(([value, cartId]) => {
        if (value && this.selectiveCartService && this.options.isSaveForLater) {
          this.selectiveCartService.updateEntry(
            value.entryNumber,
            value.quantity
          )
        } else if (value && cartId && this.userId) {
          this.multiCartService?.updateEntry(
            this.userId,
            cartId,
            value.entryNumber,
            value.quantity
          )
        } else if (value) {
          this.activeCartService.updateEntry(value.entryNumber, value.quantity)
        }
      }),
      map(() => this.form.get(this.getControlName(item)) as UntypedFormGroup)
    ) || EMPTY
  }
}
